import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddVehicleComponent } from '../add-vehicle/add-vehicle.component';

@Component({
    selector: 'app-myvehicles',
    templateUrl: './myvehicles.component.html',
    styleUrls: ['./myvehicles.component.scss'],
    standalone: false
})
export class MyvehiclesComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  onClickAddVehicle() {
    const ref = this.dialog.open(AddVehicleComponent, {
      height: '82vh',
      // width: '60vw'
    });
  }
}
